module.exports = __webpack_public_path__ + "static/media/b&s.c3a097a0.jpg";